import api from '../utils/api';

/** GET /robots-get — robot list / counts for dashboards */
export function getRobotsGet() {
  return api.get('/robots-get');
}

/** GET /robot/history — paginated disinfection history */
export function getRobotHistory(params) {
  return api.get('/robot/history', { params });
}

/** GET /robot/history/count — aggregate history count */
export function getRobotHistoryCount() {
  return api.get('/robot/history/count');
}
